/* ==========================================================================
   Sparvya v2 — configurator.js
   Visual product customizer: shape / colour / design tiles resolve to a
   variant, the gallery follows the selection, quantity drives the offer
   ladder, and add-to-cart is AJAX (no reload). Photos are collected later,
   in the basket — never on this page.
   ========================================================================== */

(function () {
  'use strict';

  var form = document.querySelector('[data-configurator]');
  var dataEl = document.querySelector('[data-variant-data]');
  if (!form || !dataEl) return;

  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!Array.isArray(variants) || !variants.length) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var els = {
    idInput:   form.querySelector('[data-variant-id]'),
    qty:       form.querySelector('[data-qty]'),
    qtyMinus:  form.querySelector('[data-qty-minus]'),
    qtyPlus:   form.querySelector('[data-qty-plus]'),
    addBtn:    form.querySelector('[data-add-btn]'),
    addTotal:  form.querySelector('[data-add-total]'),
    saveNote:  document.querySelector('[data-save-note]'),
    price:     document.querySelector('[data-price]'),
    compare:   document.querySelector('[data-compare]'),
    gallery:   document.getElementById('galleryMain'),
    liveLabel: document.querySelector('[data-live-label]'),
    addedBar:  document.querySelector('[data-added-bar]'),
    addedMsg:  document.querySelector('[data-added-msg]'),
    dismiss:   document.querySelector('[data-added-dismiss]'),
    barPrice:  document.querySelector('[data-buybar-price]'),
    barSub:    document.querySelector('[data-buybar-sub]'),
    barBtn:    document.querySelector('[data-buybar-btn]'),
    bar:       document.querySelector('[data-buybar]'),
    tiles:     document.querySelectorAll('[data-option-tiles]')
  };

  /* ---------- state ---------- */

  var selection = { 1: null, 2: null, 3: null };

  // Initialise from the first available variant
  var initial = null;
  for (var i = 0; i < variants.length; i++) {
    if (variants[i].available) { initial = variants[i]; break; }
  }
  if (!initial) initial = variants[0];
  selection[1] = initial.option1;
  selection[2] = initial.option2;
  selection[3] = initial.option3;

  function money(paise) {
    var r = paise / 100;
    return '₹' + (r % 1 === 0 ? r.toLocaleString('en-IN') : r.toLocaleString('en-IN', { minimumFractionDigits: 2 }));
  }

  /* ---------- combo exact prices (paise), keyed by quantity ---------- */
  // Read the merchant-editable combo cards → { qty: exactPriceInPaise }.
  var comboPrices = {};
  document.querySelectorAll('[data-combo]').forEach(function (c) {
    var q = parseInt(c.dataset.comboQty, 10);
    var p = parseInt(c.dataset.comboPrice, 10);
    if (!isNaN(q) && !isNaN(p) && p > 0) comboPrices[q] = p;
  });

  function resolve() {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if ((selection[1] === null || v.option1 === selection[1]) &&
          (selection[2] === null || v.option2 === selection[2]) &&
          (selection[3] === null || v.option3 === selection[3])) return v;
    }
    return null;
  }

  function imageUrl(v) {
    if (v && v.featured_image && v.featured_image.src) {
      var src = v.featured_image.src;
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
    }
    return null;
  }

  function qty() {
    var n = parseInt(els.qty && els.qty.value, 10);
    return isNaN(n) || n < 1 ? 1 : Math.min(n, 10);
  }

  /* ---------- render ---------- */

  function apply() {
    var v = resolve();
    var n = qty();

    if (v) {
      if (els.idInput) els.idInput.value = v.id;
      if (els.price) els.price.textContent = money(v.price);
      if (els.compare) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          els.compare.textContent = money(v.compare_at_price);
          els.compare.style.display = '';
        } else { els.compare.style.display = 'none'; }
      }
      // Combo price preview — an exact combo price (if the quantity matches a combo
      // card) matches the Shopify discount that charges at checkout; otherwise it's
      // the plain per-unit total.
      var gross = v.price * n;
      var total = (comboPrices[n] != null) ? comboPrices[n] : gross;
      var save = gross - total;
      if (els.addTotal) els.addTotal.textContent = '· ' + money(total);
      if (els.barPrice) els.barPrice.textContent = money(total);
      if (els.saveNote) {
        if (save > 0) {
          els.saveNote.textContent = 'You save ' + money(save) + ' with this combo';
          els.saveNote.hidden = false;
        } else {
          els.saveNote.hidden = true;
        }
      }
      if (els.barSub) els.barSub.textContent = n + (n > 1 ? ' rakhis' : ' rakhi') + ' · ' + selection[1] + ' · ' + selection[2];

      var img = imageUrl(v);
      if (img && els.gallery) {
        els.gallery.src = img;
        document.querySelectorAll('.gallery__thumb').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      }
      if (els.liveLabel) {
        els.liveLabel.textContent = selection[1] + ' · ' + selection[2] + ' · ' + selection[3];
        els.liveLabel.hidden = false;
      }

      var ok = v.available;
      if (els.addBtn) {
        els.addBtn.disabled = !ok;
        var label = els.addBtn.querySelector('[data-add-label]');
        if (label) label.textContent = ok ? (els.addBtn.dataset.label || 'Add to my box') : 'This combination is sold out';
      }
    } else if (els.addBtn) {
      els.addBtn.disabled = true;
      var lbl = els.addBtn.querySelector('[data-add-label]');
      if (lbl) lbl.textContent = 'This combination is unavailable';
    }

    // Combo card highlight — active when quantity matches the combo
    document.querySelectorAll('[data-combo]').forEach(function (c) {
      c.classList.toggle('is-on', parseInt(c.dataset.comboQty, 10) === n);
    });
  }

  /* ---------- option tiles ---------- */

  els.tiles.forEach(function (group) {
    var pos = parseInt(group.dataset.position, 10);
    var buttons = group.querySelectorAll('[data-tile]');
    var current = group.querySelector('[data-swatch-current]');

    buttons.forEach(function (btn) {
      // sync initial selection state to JS state
      if (btn.dataset.value === selection[pos]) {
        buttons.forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-checked', 'false'); });
        btn.classList.add('is-on');
        btn.setAttribute('aria-checked', 'true');
      }
      btn.addEventListener('click', function () {
        selection[pos] = btn.dataset.value;
        buttons.forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-checked', 'false'); });
        btn.classList.add('is-on');
        btn.setAttribute('aria-checked', 'true');
        if (current) current.textContent = btn.dataset.value;
        apply();
      });
    });
  });

  /* ---------- quantity ---------- */

  if (els.qtyMinus) els.qtyMinus.addEventListener('click', function () { els.qty.value = Math.max(1, qty() - 1); apply(); });
  if (els.qtyPlus) els.qtyPlus.addEventListener('click', function () { els.qty.value = Math.min(10, qty() + 1); apply(); });
  if (els.qty) els.qty.addEventListener('change', apply);

  /* ---------- combo offers: tap a card → sets the quantity ---------- */

  document.querySelectorAll('[data-combo]').forEach(function (card) {
    card.addEventListener('click', function () {
      var n = parseInt(card.dataset.comboQty, 10);
      if (els.qty && n >= 1) { els.qty.value = Math.min(n, 10); apply(); }
    });
  });

  /* ---------- AJAX add to cart ---------- */

  var busy = false;

  function addToCart() {
    if (busy) return;
    var v = resolve();
    if (!v || !v.available) return;
    busy = true;
    if (els.addBtn) els.addBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: v.id, quantity: qty() })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        // header badge
        var count = document.querySelector('.header__count');
        if (count) { count.textContent = cart.item_count; }
        // confirmation sheet
        if (els.addedMsg) {
          els.addedMsg.textContent = cart.item_count + (cart.item_count > 1 ? ' rakhis' : ' rakhi') +
            ' in your box — next, add the photos';
        }
        if (els.addedBar) els.addedBar.hidden = false;
      })
      .catch(function () {
        // graceful fallback: plain form post still works
        form.submit();
      })
      .then(function () {
        busy = false;
        apply();
      });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    addToCart();
  });

  if (els.dismiss) els.dismiss.addEventListener('click', function () { els.addedBar.hidden = true; });

  /* ---------- sticky buy bar ---------- */

  if (els.bar && els.addBtn) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { els.bar.classList.toggle('is-up', !entry.isIntersecting); });
    }, { threshold: 0 });
    io.observe(els.addBtn);
  }
  if (els.barBtn) {
    els.barBtn.addEventListener('click', function () {
      var v = resolve();
      if (v && v.available) { addToCart(); }
      else if (els.addBtn) { els.addBtn.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' }); }
    });
  }

  /* ---------- gallery thumbs (manual override of variant image) ---------- */

  document.querySelectorAll('.gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!els.gallery) return;
      els.gallery.src = thumb.dataset.full;
      document.querySelectorAll('.gallery__thumb').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
    });
  });

  if (els.addBtn) {
    var initLabel = els.addBtn.querySelector('[data-add-label]');
    if (initLabel) els.addBtn.dataset.label = initLabel.textContent;
  }

  apply();
})();
